import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToolbarComponent } from "../../../shared/components/toolbar/toolbar.component";
import { Observable } from "rxjs";
import { CourseService } from "../../services/course.service";
import { Router, RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ToastService } from "../../../shared/services/toast.service";
import { ICourse } from "../../models/course.model";
import { ICategory } from "../../../category/model/category.model";
import { Store } from "@ngrx/store";
import { courseActions } from "../../store/course.actions";
import { getCoursesSelector } from "../../store/course.selectors";

@Component({
    selector: 'clp-course-list',
    styleUrls: ['./courseList.component.scss'],
    templateUrl: './courseList.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        CommonModule,
        ToolbarComponent
    ],
    providers: [
        CourseService,
        ToastrService
    ]
})

export class CourseListComponent implements OnInit {
    private courseService = inject(CourseService);
    private router = inject(Router);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);
    private store = inject(Store);

    categories$: ICategory[] = [];
    courses$!: Observable<ICourse[]>;
    searchTerm = '';
    statusFilter: 'all' | '1' | '2' | '3' | '4' = 'all';

    ngOnInit(): void {
        this.store.dispatch(courseActions.getCourses());
        this.courses$ = this.store.select(getCoursesSelector);
    }

    editCourse(id: string | undefined ) {
        this.router.navigate(['updateCourse', id]);
    }

    deleteCourse(id: string | undefined ) {
        if (id === undefined || id === null)
            return;

        var return$ = this.courseService.deleteCourse(id);

        return$.subscribe(course => {
            if (course !== undefined && course !== null && course.id !== null) {
                this.toastService.show(this.translate.instant('course.delete.successMessage'), '');
                this.store.dispatch(courseActions.getCourses());
            }
        });
    }

    getCountByStatus(courses: ICourse[], status: number): number {
        return courses.filter(course => Number(course.status) === status).length;
    }

    onSearchChange(event: Event): void {
        this.searchTerm = (event.target as HTMLInputElement).value;
    }

    onStatusFilterChange(event: Event): void {
        this.statusFilter = (event.target as HTMLSelectElement).value as 'all' | '1' | '2' | '3' | '4';
    }

    getFilteredCourses(courses: ICourse[]): ICourse[] {
        const search = this.searchTerm.trim().toLowerCase();
        const selectedStatus = this.statusFilter;

        return courses.filter(course => {
            const title = (course.title ?? '').toLowerCase();
            const headline = (course.headline ?? '').toLowerCase();
            const matchesSearch = !search || title.includes(search) || headline.includes(search);
            const matchesStatus = selectedStatus === 'all' || String(course.status ?? '') === selectedStatus;

            return matchesSearch && matchesStatus;
        });
    }

    getStatusBadgeClass(status?: number): string {
        switch (Number(status)) {
            case 1:
                return 'border-slate-600 bg-slate-700/50 text-slate-200';
            case 2:
                return 'border-emerald-500/40 bg-emerald-500/15 text-emerald-300';
            case 3:
                return 'border-violet-500/40 bg-violet-500/15 text-violet-300';
            case 4:
                return 'border-amber-500/40 bg-amber-500/15 text-amber-300';
            default:
                return 'border-slate-600 bg-slate-700/50 text-slate-200';
        }
    }
}
